// extracted by mini-css-extract-plugin
export default {"dark":"team_dark__0wKK3","container":"team_container__c9B5n","title":"team_title__DJdl0","subtitle":"team_subtitle__rhURK","card":"team_card__d7y5G","appPlay":"team_appPlay__a5lH0"};